import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgUpdateGridConfig extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgUpdateGridConfig(params);
    }
    toData() {
        const { params } = this;
        return {
            maximum_order_value_deviation: params.maximumOrderValueDeviation,
            maximum_rebalance_retries: params.maximumRebalanceRetries,
            slippage: params.slippage,
        };
    }
    toExecData() {
        return dataToExecData('update_config', this.toData());
    }
}
